export const awardTaxonCode = 'Awards'
export const ticketTaxonCode = 'Tickets'
export const claimOnlyTaxonCode = 'ClaimOnly'

export const notForSaleProductTaxonsCodes = [awardTaxonCode, claimOnlyTaxonCode]
